import type { ITimeLine } from 'blocks/TimeLine'

import { useCallback, useMemo } from 'react'
import { ONE_MINUTE_MS } from '../constants'

type TimeLineHookParams = Pick<
  ITimeLine,
  'now' | 'scaleDivision' | 'formatTime' | 'startTime'
> & {
  step: number
  indicatorWidth: number
  titleWidth?: number
}

export const useTimeLine = ({
  now,
  startTime,
  step,
  indicatorWidth,
  titleWidth,
  scaleDivision,
  formatTime,
}: TimeLineHookParams) => {
  const minutesFromStart = useMemo(
    () => Math.trunc((now - startTime) / ONE_MINUTE_MS),
    [now, startTime]
  )

  const positionIndicator = useCallback(() => {
    if (step * minutesFromStart < indicatorWidth / 2) return 0
    return (
      step * (minutesFromStart - Math.round((indicatorWidth / 2 + 17) / step)) // 17px padding left for titles in section time
    )
  }, [step, indicatorWidth, minutesFromStart, now, scaleDivision, startTime])

  const titleTime = useCallback(
    (i: number) => {
      const shouldHideTime =
        i === 0 &&
        now >= startTime &&
        now < startTime + scaleDivision &&
        titleWidth! > positionIndicator()
      return shouldHideTime ? '' : formatTime(startTime + scaleDivision * i)
    },
    [now, titleWidth, positionIndicator, formatTime, scaleDivision, startTime]
  )

  return { positionIndicator, titleTime }
}
